import React, {useEffect, useMemo, useState} from 'react'
import ButtonsHistory from "./ButtonsHistory";

import Drawer from "@material-ui/core/Drawer";
import {Divider, Hidden, IconButton, makeStyles, Typography} from "@material-ui/core";
import ReportSidebar from "./ReportSidebar";
import PersonIcon from "@material-ui/icons/Person";
import CreateIcon from "@material-ui/icons/Create";
import NotificationsIcon from "@material-ui/icons/Notifications";
import FolderIcon from "@material-ui/icons/Folder";
import StorageIcon from "@material-ui/icons/Storage";
import BuildIcon from "@material-ui/icons/Build";
import {useSelector} from "react-redux";
import {ChevronLeft, ChevronRight, Devices, EcoSharp} from "@material-ui/icons";
import {t} from "../common/LocalizationProvider";
import clsx from "clsx";
import BarChartIcon from "@material-ui/icons/BarChart";
import PeopleIcon from "@material-ui/icons/People";
import TimelineIcon from "@material-ui/icons/Timeline";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import {useHistory, useLocation} from "react-router-dom";
import ReportNavbar from "./ReportNavbar";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { cyberStyles } from '../cssShared/cyberTheme';
import ButtonsHistoryMobile from "./ButtonsHistoryMobile";


const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
    drawer: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: theme.dimensions?.drawerWidthDesktop || 240,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: 72,
    },
}));

const baseRoutesSettings = [
    { name: 'settingsUser', href: '/user/${userId}', icon: <PersonIcon /> },
    { name: 'sharedGeofences', href: '/geofences', icon: <CreateIcon /> },
    { name: 'alerts', href: '/settings/notifications', icon: <NotificationsIcon /> },
    { name: 'settingsGroups', href: '/settings/groups', icon: <FolderIcon /> },
    { name: 'sharedDrivers', href: '/settings/drivers', icon: <PersonIcon /> },
    { name: 'sharedComputedAttributes', href: '/settings/attributes', icon: <StorageIcon /> },
    { name: 'sharedMaintenance', href: '/settings/maintenances', icon: <BuildIcon /> },
];

const routesRepports = [
    { name: 'reportRoute', href: '/reports/route', icon: <TimelineIcon /> },
    { name: 'reportEvents', href: '/reports/event', icon: <NotificationsActiveIcon /> },
    { name: 'reportTrips', href: '/reports/trip', icon: <PlayCircleFilledIcon /> },
    { name: 'reportStops', href: '/reports/stop', icon: <PauseCircleFilledIcon /> },
    { name: 'reportSummary', href: '/reports/summary', icon: <FormatListBulletedIcon /> },
    { name: 'reportChart', href: '/reports/chart', icon: <TrendingUpIcon /> },
    { name: 'reportEmissions', href: '/reports/emissions', icon: <EcoSharp /> },
];

const routesDashboard = [
    { name: 'dashboardTitle', href: '/dashboard', icon: <DashboardIcon /> },
    { name: 'statisticsTitle', href: '/admin/statistics', icon: <BarChartIcon /> },
];


const SettingsDrawer = ({hideDrawer, setHideDrawer, page}) => {
    const classes = useStyles();
    const user = useSelector(state => state.session.user);
    const location = useLocation();
    const [reportTitle, setReportTitle] = useState();
    const [openMobileDrawer, setOpenMobileDrawer] = useState(false);
    const history = useHistory();

    const routesSettings = useMemo(() => {
        let processRoutes = baseRoutesSettings.map((route) => ({...route, href: route.href.replace('${userId}', user.id)}))
        if (user?.subadmin)
            processRoutes.push({name: 'settingsUsers', href: '/admin/users', icon: <PeopleIcon/>})

        if (!user?.subadmin)
            processRoutes.push({ name: 'deviceTitle', href: `/admin/devicesInfo/${user.id}`, icon: <Devices /> })

        return processRoutes;
    },[user])

    const handleDrawerToggle = () => {
        setHideDrawer(!hideDrawer);
    };

    useEffect(() => {
        localStorage.setItem('hideDrawer', hideDrawer)
    }, [hideDrawer]);

    useEffect(() => {
        let activeRoute;
        if (page === 'repport') {
            activeRoute = routesRepports.find(r => r.href === location.pathname)
            if (location.pathname.includes('statistics'))
                setReportTitle(t('statisticsTitle'))
            else
                setReportTitle(`${t('reportTitle')} / ${t(activeRoute?.name)}`)
        }
        else if (page === 'settings') {
            activeRoute = routesSettings.find(r => r.href === location.pathname)
            setReportTitle(`${t('settingsTitle')} / ${t(activeRoute?.name)}`)
        }
        else if (page === 'users') {
            setReportTitle(`${t('settingsTitle')} / ${t('settingsUser')}`)
        }
        else if (page === 'dashboard') {
            setReportTitle(`${t('dashboardTitle')}`)
        }
        else if (page === 'replayBack') {
            setReportTitle(`${t('reportTitle')} / ${t('reportReplay')}`)
        }
        else if (page === 'devicesInfo') {
            setReportTitle(`${t('devicesInfo')}`)
        }
        else if (page === 'devices') {
            if (location.pathname.includes('connections'))
                setReportTitle(`${t('sharedConnections')}`)
            else
                setReportTitle(`${t('sharedDeviceInfo')}`)
        }
        else {
            activeRoute = routesSettings.find(r => r.href === location.pathname + 's')
            setReportTitle(`${t('settingsTitle')} / ${t(activeRoute?.name)}`)
        }
    }, [location, page, routesSettings]);

    const routesSelected = () => {
        if (page === 'repport' || page === 'replayBack')
            return location.pathname.includes('statistics') ? routesDashboard : routesRepports;
        else if (page === 'dashboard')
            return routesDashboard;
        else
            return routesSettings;
    }

    return (
        <nav>
            <Hidden smUp implementation="css">
                {page !== 'dashboard' && page !== 'replayBack' &&
                    <ReportNavbar
                        setOpenDrawer={setOpenMobileDrawer}
                        reportTitle={reportTitle}
                        history={history}/>
                }
                <Drawer
                    variant="temporary"
                    anchor='right'
                    open={openMobileDrawer}
                    onClose={() => setOpenMobileDrawer(false)}
                    classes={{ paper: classes.drawerPaperMobile }}
                    ModalProps={{ keepMounted: true }}
                >
                    <div className={classes.drawerHeader}>
                        <Typography variant="subtitle2" className={classes.drawerHeaderTitle}>
                            {reportTitle}
                        </Typography>
                    </div>
                    <Divider className={classes.divider} />
                    <ReportSidebar routes={routesSelected()} onCloseMobile={() => setOpenMobileDrawer(false)} />
                </Drawer>
                <div className={classes.mobileFooter}>
                    <ButtonsHistoryMobile hideDrawer={false} />
                </div>
            </Hidden>

            <Hidden xsDown implementation="css">
                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen] : !hideDrawer, [classes.drawerClose]: hideDrawer,
                    })}
                    classes={{
                        paper: clsx(classes.drawerPaper, {[classes.drawerOpen]: !hideDrawer, [classes.drawerClose]: hideDrawer,
                        }),
                    }}
                >
                    <Hidden xsDown>
                        <div className={classes.toolbarSpacer} />
                    </Hidden>
                    <div className={classes.drawerHeader}>
                        {!hideDrawer && (
                            <Typography variant="subtitle1" className={classes.drawerHeaderTitle} noWrap>
                                {reportTitle}
                            </Typography>
                        )}
                        <IconButton onClick={handleDrawerToggle} className={classes.toggleIcon}>
                            {hideDrawer ? <ChevronRight /> : <ChevronLeft />}
                        </IconButton>
                    </div>
                    <Divider className={classes.divider}/>
                    <ReportSidebar
                        routes={routesSelected()}
                        hideDrawer={hideDrawer}
                        onCloseMobile={() => setOpenMobileDrawer && setOpenMobileDrawer(false)}
                    />
                    <Hidden xsDown>
                        <ButtonsHistory hideDrawer={hideDrawer} />
                    </Hidden>
                </Drawer>
            </Hidden>
        </nav>
    );
}

export default React.memo(SettingsDrawer);